import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";

/***
 *
 * 获取定制商品列表 get
 * @param query 分页参数
 * @return request
 * */
export function getCustomGoodsList(query) {
    return request({
        url: `${baseURL.businessApi}/custom_goodss`,
        method: 'get',
        params: query
    })
}

/**
 * 增加定制商品 post
 * @param data 增加的数据
 * @return request
 * */
export function addCustomGoods(data) {
    return request({
        url: `${baseURL.businessApi}/custom_goodss`,
        method: 'post',
        data: data
    })
}

/**
 * 删除定制商品  delete
 * @param id 定制商品id
 * @return request
 * */
export function deleteCustomGoods(id) {
    return request({
        url: `${baseURL.businessApi}/custom_goodss/${id}`,
        method: 'delete'
    })
}

/***
 * 修改定制商品 Post
 * @param id 要修改的定制商品id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateCustomGoods(id, data) {
    return request({
        url: `${baseURL.businessApi}/custom_goodss/${id}`,
        method: 'post',
        data: data
    })
}